/* @flow */
import React from 'react';
import classNames from 'classnames';

import type { Node } from 'react';

import './InfoCard.scss';

type Props = {
  className?: string,
  children: Node,
};

export const InfoCard = ({ className, children }: Props) => {
  return <div className={classNames('ds-u-padding--2', 'ic-info-card', className)}>{children}</div>;
};

export default InfoCard;
